import 'scripts/bem'

// load the stylin
import '../_bundles/shoppingcart_popup.css'

// load the common blocks
import * as blocks from '../_bundles/shoppingcart_popup.js'

// load the run script
import Compiler from 'scripts/run.js'

Compiler.run(blocks)
